/**
 * Checks if two lists of objects have any differences.
 *
 * This function determines whether:
 * - The lists have different lengths.
 * - Any object's properties have changed at the same index.
 *
 * @template T - The type of objects in the lists.
 * @param {T[]} initialList - The original list of objects.
 * @param {T[]} modifiedList - The modified list of objects to compare.
 * @returns {boolean} - Returns `true` if the lists differ in length or if any object's properties have changed, otherwise `false`.
 *
 */
export const isModified = <T extends object>(
  initialList: T[],
  modifiedList: T[],
): boolean => {
  //Checks if length of the two object is same and returns true if it's not same
  if (initialList.length !== modifiedList.length) return true;

  return initialList.some((initialItem, index) => {
    const modifiedItem = modifiedList[index];

    const keys = Object.keys(initialItem) as (keyof T)[];
    //Checking if any key's value has changed
    return keys.some((key) => initialItem[key] !== modifiedItem[key]);
  });
};
